import React, { createContext, useContext } from "react";

import { Order, BoardItem, ProducerDef } from "../Models/Types";

export interface Orders {
  pendingOrders: Array<Order>;
}

export interface MergeGameDataContextType {
  boardItems: (BoardItem | null)[];
  setBoardItems: React.Dispatch<React.SetStateAction<(BoardItem | null)[]>>;
  fetchBoardItems: () => Promise<void>;
  saveBoardItems: (updatedBoardItems: (BoardItem | null)[]) => Promise<void>;
  gridSize: { rows: number; cols: number };
  pendingOrders: Order[];
  setPendingOrders: React.Dispatch<React.SetStateAction<Order[]>>;
  fetchOrders: () => Promise<void>;
  saveOrders: (updatedOrders: Order[]) => Promise<void>;
  itemHierarchies: any;
  allProducersDefs: ProducerDef[];
  setAllProducersDefs: React.Dispatch<React.SetStateAction<ProducerDef[]>>;
  fetchAllProducerDefs: () => Promise<void>;
  fetchItemHierarchies: () => Promise<void>;
  playerLevel: number;
  setPlayerLevel: React.Dispatch<React.SetStateAction<number>>;
  playerXP: number;
  setPlayerXP: React.Dispatch<React.SetStateAction<number>>;
  xpForNext: number;
  setXpForNext: React.Dispatch<React.SetStateAction<number>>;
}

const MergeGameDataContext = createContext<MergeGameDataContextType>(
  {} as MergeGameDataContextType
);

export const useMergeGameData = (): MergeGameDataContextType => {
  const context = useContext(MergeGameDataContext);
  if (!context) {
    throw new Error(
      "useMergeGameData must be used within a MergeGameDataProvider"
    );
  }
  return context;
};
export default MergeGameDataContext;
